/*! @pentacode/ui v0.1.0 */
import "../../weather-icon-BE0DhyCq.js";
import { formatDecimal as e, formatHour as t, formatPercent as n } from "../format.js";
import { d as r, g as i, p as a, u as o } from "../../shared-D0HMDGlg.js";
import { r as s, t as c } from "../../rule-D2ufK5oT.js";
import { r as l } from "../../scene-Bdst6a-n.js";
import { t as u } from "../../bar-COFxhm37.js";
import { n as d, t as f } from "../../mark-decorative-DmSkufit.js";
import { i as p, n as m, r as h, t as g } from "../../theme-BfnA-mmC.js";
import { html as _ } from "lit";
//#region src/charts/presets/weather.ts
var v = {
	left: 44,
	right: 12
}, y = [
	{
		icon: "thermometer-celsius",
		label: "Temperatur",
		text: (t) => `${e(t.temperature)} °C`
	},
	{
		icon: "raindrop-measure",
		label: "Niederschlag",
		text: (t) => `${e(t.precipitation)} mm`
	},
	{
		icon: "umbrella",
		label: "Regenwahrscheinlichkeit",
		text: (e) => n(e.precipitationProbability / 100)
	}
];
function b(n, _) {
	let b = Math.max(5, ...n.map((e) => e.precipitation)), x = (e) => e.datum;
	return l({
		theme: h,
		margin: v,
		marks: [
			f(u(n, {
				x: "time",
				y: "precipitation",
				yScale: "precipitation",
				fill: m[0],
				inset: 1,
				radius: { end: 2 }
			})),
			f(s(n, {
				x: "time",
				y: "precipitationProbability",
				yScale: "probability",
				stroke: m[3],
				strokeWidth: 1.5,
				strokeDasharray: "3 3",
				curve: o
			})),
			s(n, {
				x: "time",
				y: "temperature",
				stroke: m[2],
				strokeWidth: 2,
				curve: o
			}),
			..._ ? [c([_], {
				stroke: g.negative,
				strokeDasharray: "4 3"
			})] : [],
			d({
				x: !0,
				y: !1,
				stroke: g.axis,
				strokeDasharray: "3 3"
			})
		],
		scales: {
			x: {
				scale: i,
				axis: { ticks: {
					count: 5,
					format: t
				} }
			},
			y: r((t) => `${e(t)}°`),
			precipitation: {
				channel: "y",
				scale: a().domain([0, b]),
				axis: !1
			},
			probability: {
				channel: "y",
				scale: a().domain([0, 100]),
				axis: !1
			}
		},
		focus: "nearest-x",
		maxFocusDistance: Infinity,
		focusRing: !1,
		tooltip: p({ items: [{
			id: "time",
			label: "",
			text: (e) => t(e.xValue)
		}, ...y.map(({ label: e, text: t }) => ({
			id: e,
			label: e,
			text: (e) => t(x(e))
		}))] })
	});
}
function x({ defaultBody: e, primaryPoint: n, points: r }) {
	let i = (n ?? r[0])?.datum;
	return i ? _`<div
        style="display: grid; grid-template-columns: auto 1fr auto; align-items: center; gap: 0.2em 0.5em;"
    >
        ${i.icon ? _`<ptc-ui-weather-icon style="font-size: 1.5em;" .icon=${i.icon}></ptc-ui-weather-icon>
                  <span>${i.conditions}</span>` : _`<span></span><span></span>`}
        <span style="text-align: end;">${t(i.time)}</span>
        ${y.map(({ icon: e, label: t, text: n }) => _`<ptc-ui-weather-icon .icon=${e}></ptc-ui-weather-icon>
                    <span>${t}</span>
                    <span style="text-align: end; font-variant-numeric: tabular-nums;">${n(i)}</span>`)}
    </div>` : e;
}
//#endregion
export { b as weatherChart, v as weatherGutter, x as weatherTooltip };

//# sourceMappingURL=weather.js.map